import axios from "axios"
import { parseApiRequest, parseApiResponse } from "./keyChange";
// import Cookies from "js-cookie";
export const postApi = async (url,body, parseReq = false, parseRes = false, getRes = false, options = {headers: {
    Authorization : sessionStorage.getItem('accessToken')}}) => {
    if(parseReq)
        body = parseApiRequest(body)
    let response = await axios.post(url,body,options).then(res =>  res);
    if(parseRes){
        if(getRes){
            response.data = parseApiResponse(response.data)
            return response
        }
        return parseApiResponse(response.data)
    }
    if(getRes)
        return response
    return response.data
}

export const getApi = async (url, parseRes = false, getRes = false,options = {headers: {
    Authorization : sessionStorage.getItem('accessToken')}}) => {
    let response = await axios.get(url,options).then(res =>  res);
    if(parseRes){
        if(getRes){
            response.data = parseApiResponse(response.data)
            return response
        }
        return parseApiResponse(response.data)
    }
    if(getRes)
        return response
    return response.data
}

export const putApi = async (url, body?, parseRes = false, parseReq = false, getRes = false) => {
    if(parseReq)
        body = parseApiRequest(body)
    let response = await axios.put(url, body).then(res =>  res);
    if(parseRes){
        if(getRes){
            response.data = parseApiResponse(response.data)
            return response
        }
        return parseApiResponse(response.data)
    }
    if(getRes)
        return response
    return response.data
}

export const deleteApi = async (url, parseRes = false, getRes = false, options = {}) => {
    let response = await axios.delete(url).then(res =>  res);
    if(parseRes){
        if(getRes){
            response.data = parseApiResponse(response.data)
            return response
        }
        return parseApiResponse(response.data)
    }
    if(getRes)
        return response
    return response.data
}